import I18NUtils from '../i18n/I18NUtils';
export default class NonNumericsRemovalOptions {
    constructor(init) {
        this.allowNegativeSign = false;
        this.allowDecimalSeparator = false;
        this.allowGroupSeparator = false;
        this.negativeSign = I18NUtils.defaultNumberFormatInfo.negativeSign;
        this.decimalSeparator = I18NUtils.defaultNumberFormatInfo.numberDecimalSeparator;
        this.groupSeparator = I18NUtils.defaultNumberFormatInfo.numberGroupSeparator;
        Object.assign(this, init);
    }
}
//# sourceMappingURL=NonNumericsRemovalOptions.js.map